<script setup>
defineProps({
  to: {
    type: [Object, String, Boolean],
    default: false,
  },
  href: {
    type: String,
    default: null,
  },
  disabled: {
    type: [Boolean, String],
    default: false,
  },
  exact: Boolean,
})
</script>

<template>
  <a
    v-if="href"
    class="link"
    :class="{
      'text-grey-300 hover:cursor-default hover:text-grey-400!': disabled,
    }"
    :href="href"
  >
    <slot />
  </a>
  <RouterLink
    v-else-if="to"
    :exact-active-class="exact ? 'active' : 'exact-active'"
    :active-class="exact ? '' : 'active'"
    class="link"
    :class="{
      'text-grey-300 hover:cursor-default hover:text-grey-400!': disabled,
    }"
    :to="to"
  >
    <slot />
  </RouterLink>
  <span
    v-else
    class="link"
    :class="{
      'text-grey-300 hover:cursor-default hover:text-grey-400!': disabled,
    }"
    :title="disabled && typeof disabled === 'string' ? disabled : ''"
  >
    <slot />
  </span>
</template>

<style>
@reference '@/assets/style/index.css';

.link {
  @apply font-bold no-underline hover:cursor-pointer hover:text-blue-500;

  &.active {
    @apply text-blue-500;
  }
}
</style>
